export default __webpack_public_path__ + "static/media/marcos.99051308.jpeg";